import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

import { theme } from '@garnish/constants';

export const ScanToPayContainer = (props: ViewProps) => {
  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.content}>{props.children}</View>
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: theme.spacing['4'],
    gap: theme.spacing['4'],
  },
  content: {
    paddingBottom: theme.spacing['24'],
  },
});
